const mutations = {
  // ////////////////////////////////////////////
  // SIDEBAR & UI UX
  // ////////////////////////////////////////////

  UPDATE_SIDEBAR_WIDTH( state, width ) {
    state.sidebarWidth = width;
  },
  UPDATE_SIDEBAR_ITEMS_MIN( state, val ) {
    state.sidebarItemsMin = val;
  },
  TOGGLE_REDUCE_BUTTON( state, val ) {
    state.reduceButton = val;
  },
  TOGGLE_CONTENT_OVERLAY( state, val ) {
    state.bodyOverlay = val;
  },
  TOGGLE_IS_SIDEBAR_ACTIVE( state, value ) {
    state.isSidebarActive = value;
  },
  UPDATE_WINDOW_BREAKPOINT( state, val ) {
    state.breakpoint = val;
  },
  UPDATE_WINDOW_WIDTH( state, width ) {
    state.windowWidth = width;
  },

  SET_SIDEBAR_MIN( state, isMin ) {
    state.sidebarMin = isMin;
  },
  SET_SIDEBAR_ACTIVE( state, isActive ) {
    state.sidebarActive = isActive;
  },
  SET_SIDEBAR_MOBILE( state, isMobile ) {
    state.sidebarMobile = isMobile;
  },
  SET_HIGH_CONTRAST( state, isContrast ) {
    state.highContrast = isContrast;
  },
  SET_LARGER_FONT( state, isLarger ) {
    state.fontLarger = isLarger;
  },

  SET_MAINTENANCE( state, isActive ) {
    state.maintenance = isActive;
  },
  SET_ERROR404( state, isActive ) {
    state.error404 = isActive;
  },
  SET_FORBIDDEN( state, isActive ) {
    state.forbidden = isActive;
  },
};

export default mutations;
